import React, { useCallback, useEffect, useState } from 'react';
import { Grid } from '../../../../shared/grid';
import { useStoreContext } from 'src/store/context';
import { useAddAlert } from 'src/store/actions';
import { alertMessages } from 'src/constants';
import { getSiteMetaData } from 'src/apis/getFuelSampleCalls';
import { truncateFourDecimals } from 'src/store/common';
import ExpandableText from 'src/shared/ExpandableText/ExpandableText';
import moment from 'moment-timezone'
type SiteMetaDataPopUpProps = {
  id:any;
  setSiteMeta:any;
};

export const SiteMetaDataPopUp: React.FC<SiteMetaDataPopUpProps>= ({id, setSiteMeta}) =>{
  const [state, dispatch ] = useStoreContext();
  const [site, setSite] = useState<any>(null)
  const addAlert = useAddAlert(dispatch);
	const siteMeta = useCallback((id:any) =>{
		(async()=>{
			try{
				const fuelSampleMetaDataInput = {
          startDate: null,
          endDate: null,
          fuelType: "All",
          fuelSubCategory: "All",
          fuelMethod: "All",
          fuelCategory: "All",
				};
				const response: any = await getSiteMetaData(null, addAlert, id.toString(),fuelSampleMetaDataInput);
				if(response){
          setSite(response[0]);
          setSiteMeta(response[0]);
				}
			}
			catch(error){
				addAlert({
					id:'',
					message: alertMessages.retrievingStationData,
					type:'error-info',
					icon:'fa-exclamation-triangle'
				})
			}
		})();
	},[addAlert, setSite, setSiteMeta]);

  useEffect(()=>{
    siteMeta(id)
  },[id, siteMeta]);

  return(
      site && 
      <div className="font-sans-sm" style={{fontSize:'12px'}}>
        <Grid row gap="sm" style={{ paddingBottom: '.7rem' }}>
          <Grid desktop={{col:3}}>
            <Grid className="text-bold">
              LATITUDE
            </Grid>
            <Grid>
              {truncateFourDecimals(Number(site.latitude))}
            </Grid>        
          </Grid>  
          <Grid desktop={{col:5}}>
            <Grid className="text-bold">
              LONGITUDE
            </Grid>
            <Grid>
              {truncateFourDecimals(Number(site.longitude))}
            </Grid>  
          </Grid>
          <Grid desktop={{col:4}}>
            <Grid className="text-bold">
              ELEVATION
            </Grid>
            <Grid>
              {site.elevation}
            </Grid>
          </Grid>
        </Grid>

        <Grid row gap="sm" style={{paddingBottom:'.7rem'}}>
          <Grid desktop={{col:6}}>
            <Grid className="text-bold">
              AGENCY LANDOWNER
            </Grid>
            <Grid>
              {site.jurisdiction}
            </Grid>        
          </Grid>  
          <Grid desktop={{col:4}}>
              <Grid className="text-bold">
                ASPECT
              </Grid>
              <Grid>
                {site.aspect}
              </Grid>
          </Grid>
        </Grid>
      
        <Grid row gap="sm" style={{paddingBottom:'.7rem'}}>
          <Grid desktop={{col:3}}>
            <Grid className="text-bold">
              AREA NAME
            </Grid>
            <Grid>
              {site.areaName}
            </Grid>
          </Grid> 
          <Grid desktop={{col:5}}>
            <Grid className="text-bold">
              GROUP NAME
            </Grid>
            <Grid>
              {site.groupName}
            </Grid>        
          </Grid>  
          <Grid desktop={{col:4}}>
            <Grid className="text-bold">
              STATE
            </Grid>
            <Grid>
              {site.stateName}
            </Grid>
          </Grid> 
        </Grid>

        <Grid row gap="sm" style={{paddingBottom:'.7rem'}}>
          <Grid desktop={{col:3}}>
            <Grid className="text-bold">
              CREATED DATE
            </Grid>
            <Grid>
              {site.siteStartDate? moment.utc(site.siteStartDate).format('MM/DD/YYYY') : ''}
            </Grid>
          </Grid> 
          <Grid desktop={{col:2}}>
            <Grid className="text-bold">
              STATUS
            </Grid>
            <Grid>
              {site.siteStatus}
            </Grid>        
          </Grid>  
          <Grid desktop={{col:2}}>
            <Grid className="text-bold">
              SLOPE
            </Grid>
            <Grid>
              {site.slope} %
            </Grid>
          </Grid> 
          <Grid desktop={{col:4}}>
            <Grid className="text-bold">
              SAMPLE DATES
            </Grid>
            <Grid>
            {site.fuelSampleMetadata?.firstSampleDate? 
                moment.tz(site.fuelSampleMetadata.firstSampleDate, state.userTimeZone.id[0]).format('MM/DD/YYYY'):''}{site.fuelSampleMetadata?.latestSampleDate?' - ' + 
                moment.tz(site.fuelSampleMetadata.latestSampleDate, state.userTimeZone.id[0]).format('MM/DD/YYYY'):''}
            </Grid>
          </Grid>
        </Grid>

        <Grid row gap="sm" style={{paddingBottom:'.7rem'}}>
            <Grid desktop={{col:12}}>
              <Grid className="text-bold">
                REMARKS
              </Grid>
              <Grid>
              {
                  site?.remarks && site?.remarks?.length < 1 ?
                  (<>{site.remarks}</>) : (
                  site?.remarks &&
                  <ExpandableText text={site.remarks} maxWords={3} fontSize="12px"/>
                  )
              }
              </Grid>
            </Grid> 
          </Grid>
    </div>
    
  );
}
    